import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3816a0f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stat__heading" }, "Average Rating:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stat__heading" }, "Maximum Rated Item:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stat__heading" }, "Maximum Rating:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stat__heading" }, "Minimum Rated Item:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stat__heading" }, "Minimum Rating:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _directive_sentance_case = _resolveDirective("sentance-case")!

  return (_openBlock(), _createBlock(_component_Card, { class: "stat" }, {
    header: _withCtx(() => [
      _createElementVNode("img", { src: _ctx.image }, null, 8, _hoisted_1)
    ]),
    title: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createTextVNode(_toDisplayString(_ctx.stat.module), 1)
      ])), [
        [_directive_sentance_case]
      ])
    ]),
    subtitle: _withCtx(() => [
      _createTextVNode(" Total Items: " + _toDisplayString(_ctx.stat.totalItems), 1)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.stat.averageRating), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.stat.maxName), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.stat.maxRating), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_ctx.stat.minName), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_6,
        _createTextVNode(" " + _toDisplayString(_ctx.stat.minRating), 1)
      ])
    ]),
    _: 1
  }))
}